import { useRef, useEffect } from 'react';

const useLastValid = (value) => {
  const lastValid = useRef(value ?? null);

  useEffect(() => {
    if (value != null) lastValid.current = value;
  }, [value]);

  return value ?? lastValid.current;
};

export default useLastValid;
